import { useEffect, useState } from 'react'

// useMounted — returns false on the SSR render AND the client's FIRST
// (hydration) render, then flips to true after mount (post-hydration).
//
// Use ONLY for genuinely client-only overlays that must not differ between the
// SSR HTML and the client's first render (a hydration mismatch, #418/#111) —
// e.g. an interactive attribute driven by per-request/global runtime state.
// Content that is SSR-hydrated must NOT be gated on this; render it directly
// from its own data so it paints on the server (see the isLoading-gated
// sections, which were switched to gate on their OWN data instead of the global
// state.isLoading flag). Mirrors the existing post-mount patterns
// (applyShippingCountryOverlay, the #111 cart-badge fix).
export function useMounted() {
  const [mounted, setMounted] = useState(false)
  useEffect(() => {
    setMounted(true)
  }, [])
  return mounted
}
